import { TourStep } from "../inputGraphEditor/components/GuidedTour";

export const newInputEditorTourSteps: TourStep[] = [
    {
        targetSelector: "[data-tour='new-input-draw-boundary']",
        title: "Step 1 — Draw Boundary",
        description:
            "Start here. Click this to activate boundary drawing mode. Then click on the canvas to place corner points and connect them into a closed rectilinear (right-angled) shape representing your plot.",
        placement: "right",
    },
    {
        targetSelector: "[data-tour='new-input-toolbar']",
        title: "Drawing Tools",
        description:
            "Use Draw to place boundary lines, Move to pan the canvas, Fixed Room to anchor a room at a specific position, and Delete Wall to remove lines. Undo and Redo let you step through your history.",
        placement: "bottom",
    },
    {
        targetSelector: "[data-tour='new-input-finalize']",
        title: "Finalize",
        description:
            "Once your boundary is closed and correct, click Finalize to lock it in. This saves your boundary state and is required before you can generate floorplans. Always finalize after making any boundary changes.",
        placement: "bottom",
    },
    {
        targetSelector: "[data-tour='new-input-clear']",
        title: "Clear",
        description:
            "Clears everything — the boundary, all rooms, adjacency pairs, and cached state. Use this to start completely fresh. Be careful as this cannot be undone.",
        placement: "bottom",
    },
    {
        targetSelector: "[data-tour='new-input-canvas']",
        title: "Boundary Canvas",
        description:
            "Draw your plot boundary here using the grid. Click to place corner points — the grid helps you snap to clean right angles. The boundary must be fully closed before generating a floorplan.",
        placement: "right",
    },
    {
        targetSelector: "[data-tour='new-input-zoom']",
        title: "Zoom Controls",
        description:
            "Use + to zoom in for precise corner placement and - to zoom out for an overview. The current zoom level is shown between the buttons.",
        placement: "left",
    },
    {
        targetSelector: "[data-tour='new-input-rooms']",
        title: "Step 2 — Configure Rooms",
        description:
            "After drawing your boundary, expand this section to add rooms. Each room needs a name, width, and height. You can also set a max expansion value to allow rooms to grow beyond their minimum size.",
        placement: "right",
    },
    {
        targetSelector: "[data-tour='new-input-adjacency']",
        title: "Step 3 — Set Adjacency",
        description:
            "Expand this section to define which rooms should be placed next to each other — for example Kitchen next to Dining Room. These constraints guide the algorithm toward functional, realistic layouts.",
        placement: "right",
    },
    {
        targetSelector: "[data-tour='new-input-nonadjacency']",
        title: "Step 4 — Set Non-Adjacency",
        description:
            "Expand this section to define rooms that must NOT be next to each other — for example a Bathroom should not be adjacent to a Kitchen. This further refines the generated layouts.",
        placement: "right",
    },
    {
        targetSelector: "[data-tour='new-input-generate']",
        title: "Generate Floorplan",
        description:
            "Once your boundary is finalized and rooms are configured, click here to generate floorplan layouts. The algorithm places all rooms inside your boundary respecting adjacency constraints. You can preview and generate multiple variations.",
        placement: "top",
    },
    {
        targetSelector: "[data-tour='new-input-insights']",
        title: "Floorplan Insights",
        description:
            "This panel shows your Total Area, Room Area, and Remaining Area. Always keep remaining area positive — if your rooms are larger than the boundary, generation will fail. Use this to balance room sizes.",
        placement: "right",
    },
];